import FridgeChallenge from "./FridgeChallenge";
import LittlestTokyo from "./LittlestTokyo";
import ObservationSkills from "./ObservationSkills";
import VideoObservation from "./VideoObservation";
import LookAndLearn from "./LookAndLearn";
import ListeningForWhatMatters from "./ListeningForWhatMatters";

import DividedAttention from "./DividedAttention";
import Clickbait from "./Clickbait";
import FocusChallenge from "./FocusChallenge";
import VisibleHabits from "./VisibleHabits";
import MrPresident from "./MrPresident";
import WhereDidILeaveIt from "./WhereDidILeaveIt";

import EverythingHasAHome from "./EverythingHasAHome";
import PackItUp from "./PackItUp";
import WhatTimeShouldIGetUp from "./WhatTimeShouldIGetUp";
import TimeIsMoney from "./TimeIsMoney";
import ProjectManager from "./ProjectManager";
import WealthLeakCalculator from "./WealthLeakCalculator";

import ProblemSolving from "./ProblemSolving";
import ThinkWithYourHands from "./ThinkWithYourHands";
import BasketballManager from "./BasketballManager";
import TennisInTheWind from "./TennisInTheWind";
import BeforeTheyKnew from "./BeforeTheyKnew";
import SoManyOpportunities from "./SoManyOpportunities";

import ConfusingParent from "./ConfusingParent";
import Breadcrumbs from "./Breadcrumbs";
import ClearDirections from "./ClearDirections";
import EmotionalIntelligence from "./EmotionalIntelligence";
import TakingAdvice from "./TakingAdvice";
import WhyShouldI from "./WhyShouldI";

import FactsAndValues from "./FactsAndValues";
import FallacyDetective from "./FallacyDetective";
import HouseAlwaysWins from "./HouseAlwaysWins";
import Bookmaker from "./Bookmaker";
import WhatCanILearnFromThis from "./WhatCanILearnFromThis";
import MemoryPalace from "./MemoryPalace";

import SmallTalk from "../activities/SmallTalk";
import LifeGoals from "./LifeGoals";
import BiasTranslator from "./BiasTranslator";
import Persuasion from "./Persuasion";
import ObservationSkills2 from "./ObservationSkills2";
import Meditation from "./Meditation";

import BeatProcrastination from "./BeatProcrastination";
import FieldOfficer from "./FieldOfficer";
import BeforeTheyKnew2 from "./BeforeTheyKnew2";
import Banter from "./Banter";
import HiddenArguments from "./HiddenArguments";
import FocusLab from "./FocusLab";

export const activityRegistry = {

    "fridge": FridgeChallenge,
    "littlest-tokyo": LittlestTokyo,
    "observation-skills": ObservationSkills,
    "video-observation": VideoObservation,
    "look-and-learn": LookAndLearn,
    "listening-for-what-matters": ListeningForWhatMatters,
    "observation-skills-2": ObservationSkills2,

    "divided-attention": DividedAttention,
    "clickbait": Clickbait,
    "focus-challenge": FocusChallenge,
    "visible-habits": VisibleHabits,
    "yes-mr-president": MrPresident,
    "where-did-i-leave-it": WhereDidILeaveIt,

    "everything-has-a-home": EverythingHasAHome,
    "pack-it-up": PackItUp,
    "what-time-should-i-get-up": WhatTimeShouldIGetUp,
    "time-is-money": TimeIsMoney,
    "project-manager": ProjectManager,
    "wealth-leak-calculator": WealthLeakCalculator,

    "problem-solving": ProblemSolving,
    "think-with-your-hands": ThinkWithYourHands,
    "basketball-manager": BasketballManager,
    "tennis-in-the-wind": TennisInTheWind,
    "before-they-knew": BeforeTheyKnew,
    "so-many-opportunities": SoManyOpportunities,

    "confusing-parent": ConfusingParent,
    "breadcrumbs": Breadcrumbs,
    "clear-directions": ClearDirections,
    "emotional-intelligence": EmotionalIntelligence,
    "taking-advice": TakingAdvice,
    "why-should-i": WhyShouldI,
    "small-talk": SmallTalk,

    "facts-and-values": FactsAndValues,
    "fallacy-detective": FallacyDetective,
    "house-always-wins": HouseAlwaysWins,
    "bookmaker": Bookmaker,
    "what-can-i-learn-from-this": WhatCanILearnFromThis,
    "memory-palace": MemoryPalace,
    "bias-translator": BiasTranslator,

    "life-goals": LifeGoals,
    "persuasion": Persuasion,
    "meditation": Meditation,
    "beat-procrastination": BeatProcrastination,
    "field-officer": FieldOfficer,
    "before-they-knew-2": BeforeTheyKnew2,
    "banter": Banter,
    "hidden-arguments": HiddenArguments,
    "focus-lab": FocusLab
};